import { createAsyncThunk } from "@reduxjs/toolkit";
import { IStoreSlice, TArticle } from "@/redux/slices/store/types";
import { apiContent, ApiPostResponseItem } from "@/lib/api/content";
import { transformPosts } from "@/lib/utils/posts";

export const getStoreArticles = createAsyncThunk(
  "store/getStoreArticles",
  async () => {
    const { getPosts } = apiContent;

    const postData: ApiPostResponseItem[] = await getPosts();
    return transformPosts(postData);
  }
);

const pending = (state: IStoreSlice) => {
  state.articles = {
    loaded: false,
    articles: [],
  };
};

const failed = (state: IStoreSlice) => {
  state.articles.loaded = false;
};

const fulfilled = (
  state: IStoreSlice,
  { payload }: { payload: TArticle[] }
) => {
  state.articles = {
    loaded: true,
    articles: payload,
  };
};

export default {
  action: getStoreArticles,
  pending,
  fulfilled,
};
